<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="component-list-card h-100 d-flex flex-column align-items-center">
    <!-- <img class="payment_proc_image" [src]="!item.ImagePath ? imagePath :item.ImagePath " alt="profile-picture"> -->
    <div class="text-center mb-2 ">
        <label class="lbl_proc_name">{{paymentProcessorModel.paymentProcessorName}}</label><br>
        <label class="lbl_proc_web"><a href="{{paymentProcessorModel.processorWebUrl}}"
                target="_blank">{{paymentProcessorModel.processorWebUrl}}</a></label>
    </div>
    <div class="w-100 mt-auto">
        <i *ngIf="errorModel!=null && errorModel['countryIds']!=null"
            class="pi pi-exclamation-circle float-end me-1 error_color"
            pTooltip="{{errorModel['countryIds']|translate}}" tooltipPosition="top"></i>
        <label class="lbl_proc text-start w-100">{{ 'BUSINESS.CHOOSE_COUNTRY' | translate | uppercase}}</label>
        <p-multiSelect id="no_borders" class="src_dropdown" filterPlaceHolder="{{'SEARCH' | translate}}..."
            [options]="countryItem" [(ngModel)]="contires" defaultLabel="{{'BUSINESS.SELECT_COUNTRY'|translate}}"
            [showHeader]="false" optionLabel="countryName" optionValue="id" [maxSelectedLabels]="5"
            selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}"></p-multiSelect>
    </div>
    <div class="w-100 mt-4">
        <!-- <button *ngIf="!enableEdit" class="btn_in_color mb-2" (click)="savePaymentProcessor(paymentProcessorModel)">{{"SAVE" | translate}}</button> -->
        <button *ngIf="enableEdit" class="btn_in_color mb-2"
            (click)="editPaymentProcessor(paymentProcessorId,contires)">{{"SAVE" | translate}}</button>
        <button class="btn_without_color btn_border_color mb-2 ms-2" (click)="cancel()">{{"CANCEL" |
            translate}}</button>
    </div>
</div>